import React, { useState } from "react";
import NotePreview from "./NotePreview";

const AttendanceCell = ({ code, note, onChange, updatedBy, recordId }) => {
  const [showNoteEditor, setShowNoteEditor] = useState(false);
  const [tempNote, setTempNote] = useState(note || "");
  const [isHovered, setIsHovered] = useState(false);

  const attendanceOptions = ["", "Call In", "Incentive Day", "Leave Early", "PTO", "Tardy"];

  const labelMap = {
    "": "--",
    "Call In": "C",
    "Incentive Day": "I",
    "Leave Early": "L",
    "PTO": "P",
    "Tardy": "T",
  };

  /* ——— helper handlers ——— */
  const handleMouseEnter = () => {
    if (showNoteEditor) return;        // ⛔ ignore while editor open
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    if (showNoteEditor) return;        // ⛔ ignore while editor open
    setIsHovered(false);
  };

  const handleChange = (e) => {
    onChange(recordId, e.target.value, note);
  };

  const handleSaveNote = () => {
    onChange(recordId, code, tempNote);
    setShowNoteEditor(false);
  };

  return (
    <div
      className="attendance-cell"
      style={{ position: "relative" }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onDoubleClick={() => setShowNoteEditor(true)}
    >
      <div className="select-overlay">{labelMap[code || ""]}</div>

      <select
        value={code || ""}
        onChange={handleChange}
        className="attendance-select no-arrow"
      >
        {attendanceOptions.map((opt) => (
          <option key={opt} value={opt}>
            {opt === "" ? "--" : opt}
          </option>
        ))}
      </select>

      {note && <div className="note-indicator" />}

      {isHovered && <NotePreview note={note} updatedBy={updatedBy} />}

      {showNoteEditor && (
        <div className="note-popup">
          {updatedBy && <div className="note-author">Last updated by: {updatedBy}</div>}
          <textarea
            value={tempNote}
            onChange={(e) => setTempNote(e.target.value)}
            placeholder="Enter note..."
          />
          <div className="note-actions">
            <button onClick={handleSaveNote}>Save</button>
            <button onClick={() => setShowNoteEditor(false)}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AttendanceCell;
